import { Modal } from "antd";
import { BiPrinter } from "react-icons/bi";

const PackSlipPrint = ({
  showPreview,
  closePreview,
  tempInvoiceLink,
  printSlipCall,
  loading,
}) => {
  return (
    <Modal
      title={"Invoice"}
      open={showPreview}
      onCancel={() => {
        closePreview();
        // if (isRedirect) {
        //   setTimeout(() => {
        //     navigate.push("/checker-live");
        //   }, 200);
        // }
      }}
      footer={null}
      bodyStyle={{ padding: "10px" }}
    >
      <div>
        <iframe
          title="Invoice"
          style={{
            width: "100%",
            height: "60vh",
            "border-radius": "4px",
          }}
          src={tempInvoiceLink}
        ></iframe>
      </div>
      {printSlipCall ? (
        <>
          <br />
          <button
            className="bbtn"
            onClick={() => printSlipCall()}
            disabled={loading}
          >
            <BiPrinter />
            Print Pack Slip
          </button>
        </>
      ) : null}
    </Modal>
  );
};

export default PackSlipPrint;
